import { Home } from './components/Home';
import { Ingredients } from './components/Ingredients';
import { SelectedRecipes } from './stateContainers';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import 'semantic-ui-css/semantic.min.css';
import './App.css';
import { Container } from 'semantic-ui-react';

function App() {
    return (
        <SelectedRecipes.Provider>
            <Container style={{ paddingTop: '1em', paddingBottom: '60px' }}>
                <Router>
                    <Switch>
                        <Route path="/ingredients">
                            <Ingredients />
                        </Route>
                        <Route path="/">
                            <Home />
                        </Route>
                    </Switch>
                </Router>
            </Container>
        </SelectedRecipes.Provider>
    );
}

export default App;
